export const groupBookingsByWeek = (bookings = []) => {
  let output = { week1: [] }

  bookings.forEach(booking => {
    switch (String(booking.cycleWeekNumber)) {
    case '2':
      (output.week2 ? output.week2 : (output.week2 = [])).push(booking)
      break
    case '1':
      output.week1.push(booking)
      break
    default:
      break
    }
  })

  return output
}

export const feeIsHourly = ({ feeFrequency = '', sessionUnitOfMeasure = '' }) => !!(feeFrequency.match(/hour/i)) || !!(sessionUnitOfMeasure.match(/hour/i))



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/booking-schedules/helper.js